import { Box, Button, Stack, Typography, alpha, useTheme } from '@mui/material';
import { Download } from 'lucide-react';
import type { HansAckerScan } from './types';

const mono = { fontFamily: "'Consolas', monospace" };

export default function PreviousScans({ scans }: { scans: HansAckerScan[] }) {
  const theme = useTheme();
  return (
    <Box id="hans-acker-scans" sx={{ scrollMarginTop: 72, bgcolor: 'background.paper', border: '1px solid', borderColor: 'divider', borderRadius: 3, p: 2.5 }}>
      <Stack direction="row" alignItems="baseline" spacing={1.5} sx={{ mb: 2 }}>
        <Typography sx={{ fontSize: 16, fontWeight: 700 }}>Previous scans</Typography>
        <Typography sx={{ ml: 'auto', fontSize: 12, color: 'text.disabled' }}>Only the latest scan is shown in detail above</Typography>
      </Stack>
      <Stack spacing={1.25}>
        {scans.map((s) => (
          <Stack
            key={s.id}
            direction="row"
            spacing={2}
            alignItems="center"
            sx={{ px: 2, py: 1.5, borderRadius: 2, border: '1px solid', borderColor: 'divider', bgcolor: alpha(theme.palette.text.primary, 0.025), flexWrap: 'wrap', rowGap: 1 }}
          >
            <Box sx={{ flex: 1, minWidth: 240 }}>
              <Typography sx={{ ...mono, fontSize: 13, fontWeight: 700, overflowWrap: 'anywhere' }}>{s.id}</Typography>
              <Typography sx={{ fontSize: 12, color: 'text.secondary', mt: 0.4 }}>
                {s.scannedAt} {'\u00b7'} {s.duration} {'\u00b7'} {s.mode} {'\u00b7'} {s.findings} finding{s.findings === 1 ? '' : 's'}
              </Typography>
            </Box>
            {s.latest && (
              <Box component="span" sx={{ fontSize: 10.5, fontWeight: 800, letterSpacing: 0.6, textTransform: 'uppercase', color: '#3b82f6', bgcolor: alpha('#60a5fa', 0.16), borderRadius: 0.75, px: 1, py: 0.35 }}>
                Latest {'\u2014'} shown above
              </Box>
            )}
            {s.downloadUrl && (
              <Button size="small" variant="outlined" startIcon={<Download size={14} />} component="a" href={s.downloadUrl} download sx={{ textTransform: 'none' }}>
                Download folder
              </Button>
            )}
          </Stack>
        ))}
      </Stack>
    </Box>
  );
}
